import type { ReactNode } from 'react'
import { X } from 'lucide-react'
import { Button } from '~/components/ui/button'
import { cn } from '~/lib/utils'

// 범용 "일괄작업 바". 특정 목록에 의존하지 않는다 — 선택 수·액션·해제 콜백만 받는다.
// 선택 수가 0이면 렌더하지 않는다(빈 선택 시 숨김). 미니멀(카드·border·shadow-sm),
// sticky 옵션으로 목록 상단/하단에 떠오르게 둘 수 있다. 다크 자동 적응(시맨틱 토큰만).
export function BulkActionBar({
    count,
    onClear,
    children,
    sticky = false,
    position = 'bottom',
    className,
}: {
    /** 선택된 항목 수. 0이면 바를 숨긴다. */
    count: number
    /** "선택 해제" 클릭. */
    onClear: () => void
    /** 액션 버튼들(예: 내보내기·일괄 편집). */
    children?: ReactNode
    /** 스크롤에 붙어 떠오르게 한다. */
    sticky?: boolean
    /** sticky 시 위/아래 어디에 붙일지. */
    position?: 'top' | 'bottom'
    className?: string
}) {
    if (count <= 0) return null

    return (
        <div
            role='region'
            aria-label={`${count}개 선택됨, 일괄 작업`}
            className={cn(
                'border-border bg-card flex items-center gap-3 rounded-[var(--radius)] border px-3 py-2 shadow-sm',
                sticky && 'sticky z-10',
                sticky && (position === 'top' ? 'top-3' : 'bottom-3'),
                className
            )}>
            <span className='text-foreground shrink-0 text-[13px] font-semibold'>
                <span aria-live='polite'>{count.toLocaleString()}</span>개 선택
            </span>
            <div className='flex flex-1 flex-wrap items-center gap-2'>
                {children}
            </div>
            <Button
                variant='ghost'
                size='sm'
                onClick={onClear}
                className='shrink-0'>
                <X />
                선택 해제
            </Button>
        </div>
    )
}
